export default __webpack_public_path__ + "static/media/no_data.9f9ab394.png";